export const ASSET_CONTROL_PERMISSION_PATH = [
    { permission: 'ASSET_CONTROL_1', path: '/AC_1', urlKey: 'AC_1' },
];